import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {"defaultBreakpoint":"sm","breakpoints":{"mobile":375,"phablet":768,"tablet":1024,"desktop":1440,"desktopHD":Infinity}})
